import { CaseSizeRuleCreateRequestType } from "@sellar-io/api-v2/types";
import { useId } from "react";
import {
  Button,
  useFullPageDialogContext,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "@sellar-io/components";
import { CaseSizeRuleCreateDialogPage } from "../CaseSizeRuleCreateDialogPage";
import { CreatePackageRuleForm } from "./CreatePackageRuleForm";

export const CreatePackageRulePage = ({
  caseSizeRule,
  setCaseSizeRule,
}: {
  caseSizeRule: CaseSizeRuleCreateRequestType | undefined;
  setCaseSizeRule: (caseSizeRule: CaseSizeRuleCreateRequestType) => void;
}) => {
  const { onDismiss, setPage } = useFullPageDialogContext();
  const formId = useId();

  return (
    <>
      <DialogNavigation
        title={"Add case size rule"}
        description={``}
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
      />

      <DialogContent>
        <CreatePackageRuleForm
          formId={formId}
          initialValues={caseSizeRule}
          onSubmit={(data) => {
            setCaseSizeRule(data);
            setPage(CaseSizeRuleCreateDialogPage.UPDATE_MOQ_RULES);
          }}
        />
      </DialogContent>
      <DialogCTA>
        <Button type="submit" form={formId}>
          Next
        </Button>
      </DialogCTA>
    </>
  );
};
